import { render } from "./DocumentsRessourcesHumaines.vue?vue&type=template&id=06020d26"
import script from "./DocumentsRessourcesHumaines.vue?vue&type=script&lang=js"
export * from "./DocumentsRessourcesHumaines.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__